import {
  LokalizacjaUszkodzenia,
  lokalizacjeUszkodzenBudowle,
  lokalizacjeUszkodzenBudynekNiemieszkalny,
  lokalizacjeUszkodzenDomJednorodzinny,
  lokalizacjeUszkodzenGaraz, lokalizacjeUszkodzenInne,
  lokalizacjeUszkodzenMieszkanie, lokalizacjeUszkodzenOszkleniaWitraze,
  lokalizacjeUszkodzenPrzedmiotySzklane
} from '../uszkodzenia/lokalizacja-uszkodzenia';

export class TypPrzedmiotuUbezpieczenia {
  public static readonly MIESZKANIE = new TypPrzedmiotuUbezpieczenia('mieszkanie', '20_33', undefined, lokalizacjeUszkodzenMieszkanie)
  public static readonly DOM_JEDNORODZINNY = new TypPrzedmiotuUbezpieczenia('domJednorodzinny', '20_1', 'assets/images/01_Dom_jednorodzinny_21_10_13 1.svg',
    lokalizacjeUszkodzenDomJednorodzinny)
  public static readonly BUDYNEK_NIEMIESZKALNY = new TypPrzedmiotuUbezpieczenia('budynekNiemieszkalny', '20_4', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png',
    lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly GARAZ = new TypPrzedmiotuUbezpieczenia('garaz', '20_29', 'assets/images/02_Garaz_21_11_26.png', lokalizacjeUszkodzenGaraz)
  public static readonly PRZEDMIOTY_SZKLANE = new TypPrzedmiotuUbezpieczenia('przedmiotySzklane', '19_2', '', lokalizacjeUszkodzenPrzedmiotySzklane)
  public static readonly BUDOWLE = new TypPrzedmiotuUbezpieczenia('budowle', '15_21', '', lokalizacjeUszkodzenBudowle)
  public static readonly INNE = new TypPrzedmiotuUbezpieczenia('inne', '4_9', '', lokalizacjeUszkodzenInne)
  public static readonly BUDYNEK_GOSPODARCZY = new TypPrzedmiotuUbezpieczenia('budynekGospodarczy', '20_4', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly STODOLA = new TypPrzedmiotuUbezpieczenia('stodola', '20_35', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly MAGAZYN = new TypPrzedmiotuUbezpieczenia('magazyn', '20_34', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly KURNIK = new TypPrzedmiotuUbezpieczenia('kurnik', '20_32', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly OBORA = new TypPrzedmiotuUbezpieczenia('obora', '20_26', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly KURNIK_FERMOWY = new TypPrzedmiotuUbezpieczenia('kurnikFermowy', '20_32', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly CHLEWNIA = new TypPrzedmiotuUbezpieczenia('chlewnia', '20_36', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly STAJNIA = new TypPrzedmiotuUbezpieczenia('stajnia', '20_28', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly BUDYNEK_INWENTARSKI = new TypPrzedmiotuUbezpieczenia('budynekInwentarski', '20_31', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly BUDYNEK_FERMOWY = new TypPrzedmiotuUbezpieczenia('budynekFermowy', '20_32', 'assets/images/image-2023-01-20-15-39-05-315.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly PRZECHOWALNIA_OWOCOW_I_WARZYW = new TypPrzedmiotuUbezpieczenia('przechowalniaOwocowIWarzyw', '20_25', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly PIECZARKARNIA = new TypPrzedmiotuUbezpieczenia('pieczarkarnia', '20_31', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly PAWILON = new TypPrzedmiotuUbezpieczenia('pawilon', '20_31', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly BUDYNEK_WIELOFUNKCYJNY = new TypPrzedmiotuUbezpieczenia('budynekWielofunkcyjny', '20_2', 'assets/images/03_Budynek_niemieszkalny_21_11_26.png', lokalizacjeUszkodzenBudynekNiemieszkalny)
  public static readonly OSZKLENIA_WITRAZE = new TypPrzedmiotuUbezpieczenia('oszkleniaWitraze', '19_2', '', lokalizacjeUszkodzenOszkleniaWitraze)
  public static readonly MEBLE = new TypPrzedmiotuUbezpieczenia('meble', '19_20', '', [])
  public static readonly SPRZET_AGD_RTV = new TypPrzedmiotuUbezpieczenia('sprzet_agd_rtv', '16_4', '', [])

  public static readonly typyPrzedmiotuUbezpieczenia = [
    TypPrzedmiotuUbezpieczenia.MIESZKANIE,
    TypPrzedmiotuUbezpieczenia.DOM_JEDNORODZINNY,
    TypPrzedmiotuUbezpieczenia.BUDYNEK_NIEMIESZKALNY,
    TypPrzedmiotuUbezpieczenia.GARAZ,
    TypPrzedmiotuUbezpieczenia.PRZEDMIOTY_SZKLANE,
    TypPrzedmiotuUbezpieczenia.BUDOWLE,
    TypPrzedmiotuUbezpieczenia.INNE,
    TypPrzedmiotuUbezpieczenia.BUDYNEK_GOSPODARCZY,
    TypPrzedmiotuUbezpieczenia.STODOLA,
    TypPrzedmiotuUbezpieczenia.MAGAZYN,
    TypPrzedmiotuUbezpieczenia.KURNIK,
    TypPrzedmiotuUbezpieczenia.OBORA,
    TypPrzedmiotuUbezpieczenia.KURNIK_FERMOWY,
    TypPrzedmiotuUbezpieczenia.CHLEWNIA,
    TypPrzedmiotuUbezpieczenia.STAJNIA,
    TypPrzedmiotuUbezpieczenia.BUDYNEK_INWENTARSKI,
    TypPrzedmiotuUbezpieczenia.BUDYNEK_FERMOWY,
    TypPrzedmiotuUbezpieczenia.PRZECHOWALNIA_OWOCOW_I_WARZYW,
    TypPrzedmiotuUbezpieczenia.PIECZARKARNIA,
    TypPrzedmiotuUbezpieczenia.PAWILON,
    TypPrzedmiotuUbezpieczenia.BUDYNEK_WIELOFUNKCYJNY,
    TypPrzedmiotuUbezpieczenia.OSZKLENIA_WITRAZE,
    TypPrzedmiotuUbezpieczenia.MEBLE,
    TypPrzedmiotuUbezpieczenia.SPRZET_AGD_RTV
  ]

  constructor(readonly nazwa: string,
              readonly ikona: string,
              readonly obraz: string | undefined,
              readonly lokalizacjeUszkodzen: Array<LokalizacjaUszkodzenia>) {
  }

  static pobierz(nazwa: string | undefined): TypPrzedmiotuUbezpieczenia | undefined {
    return TypPrzedmiotuUbezpieczenia.typyPrzedmiotuUbezpieczenia.find(typ => typ.nazwa === nazwa)
  }
}
